import React from "react";
import TreeAndTableLayout from "../../../../components/TreeAndTableLayout/TreeAndTableLayout";
import { filterForEach, generateTreeData, treeForEach } from "../../../../utils";
import BaseComponent from "../../../../base/BaseComponent";
import TableOperation from "./tableOperation/TableOperation";
import TableToolBar from "./tableToolBar/TableToolBar";
import { message } from "../../utils/sysManagementUtils";
import PermissionTreeEditModal from "./PermissionTreeEditModal/PermissionTreeEditModal";
import PermissionEditModal from "./permissionEditModal/PermissionEditModal";
import ContentWrap from "../../components/ContentWrap";

export default class PermissionList extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            treeData: [],
            treeDataIndex: {
                id: "id",
                title: "name",
                children: "child",
                key: "id"
            },
            selectedKeys: [],
            pageSize: 10,
            currentPage: 1,
            columns: [],
            count: 0,
            tableData: [],
            tableIsLoading: false,

            searchValue: "",
            expandedKeys: [],
            autoExpandParent: true,

            editTree: null,
            editPermission: null,
            permissionTreeEditVisible: false,
            permissionEditVisible: false
        };
    }

    componentDidMount() {
        this.getTreeData();
        this.getColumns();
        this.getTableData();
    }

    render() {
        const {
            selectedKeys,
            treeData,
            pageSize,
            currentPage,
            columns,
            count,
            tableData,
            tableIsLoading,
            searchValue,
            expandedKeys,
            autoExpandParent,
            editTree,
            editPermission,
            permissionEditVisible,
            permissionTreeEditVisible
        } = this.state;
        return (
            <ContentWrap>
                <TreeAndTableLayout
                    showIcon={true}
                    selectedKeys={selectedKeys}
                    treeData={treeData}
                    onSelect={this.onTreeSelect}
                    expandedKeys={expandedKeys}
                    showTreeOperation={true}
                    autoExpandParent={autoExpandParent}
                    onTreeAdd={data => this.showPermissionTreeEdit({ fid: data.id })}
                    onTreeEdit={data => this.showPermissionTreeEdit(data.data)}
                    onTreeDelete={data => this.onTreeDelete(data)}
                    onExpand={this.onExpand}
                    pageSize={pageSize}
                    current={currentPage}
                    columns={columns}
                    count={count}
                    tableData={tableData}
                    tableIsLoading={tableIsLoading}
                    ToolBar={
                        <TableToolBar
                            searchValue={searchValue}
                            onSearchValueChange={searchValue => this.setState({ searchValue })}
                            onSearch={this.onSearch}
                            updateTable={this.getTableData}
                            onTreeSelect={this.onTreeSelect}
                            showPermissionEdit={() => this.showPermissionEdit({ permissionClassifyTreeId: selectedKeys[0] })}
                        />
                    }
                    onChange={this.onPageChange}
                    onShowSizeChange={this.onShowSizeChange}
                />

                <PermissionEditModal
                    visible={permissionEditVisible}
                    data={editPermission}
                    handleCancel={this.hidePermissionEdit}
                    handleOk={this.submitPermissionEdit}
                />

                <PermissionTreeEditModal
                    visible={permissionTreeEditVisible}
                    data={editTree}
                    handleCancel={this.hidePermissionTreeEdit}
                    handleOk={this.submitPermissionTreeEdit}
                />
            </ContentWrap>
        );
    }

    showPermissionEdit = editPermission => {
        this.setState({
            editPermission,
            permissionEditVisible: true
        });
    };

    hidePermissionEdit = () => {
        this.setState({
            permissionEditVisible: false,
            editPermission: null
        });
    };

    submitPermissionEdit = data => {
        message.destroy();
        if (data.id) {
            this.editPermission(data);
        } else {
            this.addPermission(data);
        }
    };

    editPermission = data => {
        this.editPermissionRequest(data, res => {
            message.success("权限修改成功");
            this.hidePermissionEdit();
            this.getTableData();
        });
    };

    addPermission = data => {
        this.addManagerPermission(data, res => {
            message.success("权限添加成功");
            this.setState({
                currentPage: 1
            }, () => {
                this.hidePermissionEdit();
                this.getTableData();
            });

        });
    };

    submitPermissionTreeEdit = data => {
        message.destroy();
        if (data.id) {
            this.editPermissionClassify(data);
        } else {
            this.addPermissionClassify(data);
        }
    };

    showPermissionTreeEdit = (editTree) => {
        this.setState({
            permissionTreeEditVisible: true,
            editTree
        });
    };

    hidePermissionTreeEdit = () => {
        this.setState({
            permissionTreeEditVisible: false
        });
    };

    onExpand = expandedKeys => {
        this.setState({
            expandedKeys,
            autoExpandParent: false
        });
    };

    expandKey = key => {
        const { expandedKeys, treeData } = this.state;
        const tree = filterForEach(treeData, node => {
            return node.id === key;
        });
        const keys = [];
        treeForEach(tree, node => {
            keys.push(node.id);
        });
        this.setState({
            expandedKeys: [...(new Set([...expandedKeys, ...keys]))],
            autoExpandParent: false
        });
    };

    onSearch = () => {
        this.setState({
            currentPage: 1
        }, () => {
            this.getTableData();
        });
    };
    /**
     * 当页码变换的回调
     * @param page
     * @param pageSize
     */
    onPageChange = (page, pageSize) => {
        this.setState({
            currentPage: page,
            pageSize: pageSize
        }, () => {
            this.getTableData();
        });
    };

    /**
     * pageSize 变化的回调
     * @param current
     * @param size
     */
    onShowSizeChange = (current, size) => {
        this.setState({
            pageSize: size,
            currentPage: 1
        }, () => {
            this.getTableData();
        });
    };

    onTreeSelect = (selectKeys, e) => {
        this.setState({
            currentPage: 1,
            selectedKeys: selectKeys,
            searchValue: ""
        }, () => {
            this.getTableData();
        });
    };

    getTreeData = () => {
        const { treeDataIndex, selectedKeys } = this.state;
        this.getPermissionTreeRequest(res => {
            const treeData = generateTreeData([res], treeDataIndex);
            if (!selectedKeys.length) {
                const expandedKeys = [];
                treeForEach(treeData, node => {
                    if (node.children && node.children.length) {
                        expandedKeys.push(node.id);
                    }
                });
                this.setState({
                    expandedKeys,
                    treeData
                }, () => {
                    this.onTreeSelect([treeData[0].id])
                });
            }
            this.setState({
                treeData
            });
        });
    };

    getTableData = () => {
        const {
            pageSize,
            currentPage: pageNum,
            searchValue,
            selectedKeys
        } = this.state;
        this.setState({
            tableIsLoading: true
        });
        const params = {
            permissionTreeId: selectedKeys[0], pageSize, pageNum, name: searchValue, code: searchValue
        };
        this.findPermissionRequest(params, res => {
            const { data, count } = res;
            if (count && count <= (pageNum - 1) * pageSize) {
                this.onPageChange(pageNum - 1, pageSize);
            } else {
                this.setState({
                    tableIsLoading: false,
                    tableData: data,
                    count
                });
            }
        });
    };

    getColumns = () => {
        const columns = [
            {
                title: "权限名称",
                dataIndex: "name",
                width: 160,
                ellipsis: true
            },
            {
                title: "编码",
                dataIndex: "code",
                width: 160,
                ellipsis: true
            },
            {
                title: "排序",
                dataIndex: "permissionSort",
                width: 100,
                ellipsis: true
            },
            {
                title: "描述",
                dataIndex: "remark",
                width: 200,
                ellipsis: true

            },
            {
                title: "操作",
                width: 200,
                render: (text, record) => <TableOperation
                    data={record}
                    showPermissionEdit={this.showPermissionEdit}
                    deleteTableItem={this.deletePermission}
                />
            }
        ];
        this.setState({
            columns
        });
    };

    onTreeUpdate = () => {
        this.hidePermissionTreeEdit();
        this.getTreeData();
    };

    addPermissionClassify = data => {
        this.addPermissionClassifyRequest(data, res => {
            this.onTreeUpdate();
            this.expandKey(data.fid);
            message.success("权限分类添加成功");
        });
    };

    editPermissionClassify = data => {
        if (data.id === data.fid) {
            message.error("上级分类不能选择当前权限分类");
            return false;
        }
        this.editPermissionClassifyRequest(data, res => {
            this.onTreeUpdate();
            this.expandKey(data.fid);
            message.success("权限分类已修改");
        });
    };

    onTreeDelete = data => {
        const { selectedKeys } = this.state
        this.deleteTreeAndPermissionRequest(data.id, res => {
            message.success(`权限分类删除成功`);
            this.setState({
                selectedKeys: selectedKeys.filter(item => item !== data.id)
            }, () => {
                this.getTreeData();
            })
        });
    };
    deletePermission = data => {
        this.deletePermissionByIdRequest(data.id, res => {
            this.getTableData();
            message.success(`权限删除成功`);
        });
    };
    //// 接口请求 /
    getPermissionTreeRequest = (callBack) => {
        this.request({
            url: "/cm-sites-sys/permission/classify/findTree",
            callBack
        });
    };

    /**
     * @param permissionTreeId
     * @param pageSize
     * @param pageNum
     * @param name
     * @param code
     * @param callBack
     */
    findPermissionRequest = ({ permissionTreeId, pageSize, pageNum, name, code }, callBack) => {
        if (!permissionTreeId) {
            permissionTreeId = 0;
        }
        this.request({
            url: "/cm-sites-sys/permission/manager/findListByNameOrCodeList",
            body: { permissionTreeId, pageSize, pageNum, name, code },
            method: "post",
            contentType: 'json',
            callBack
        });
    };

    editPermissionClassifyRequest = ({ id, fid, name }, callBack) => {
        this.request({
            url: "/cm-sites-sys/permission/classify/edit",
            method: "POST",
            contentType: "json",
            body: {
                id, name, fid
            },
            callBack
        });
    };

    /**
     * 删除节点
     * @param id
     * @param callBack
     */
    deleteTreeAndPermissionRequest = (id, callBack) => {
        this.request({
            url: "/cm-sites-sys/permission/classify/deleteTreeAndPermission",
            method: "POST",
            body: { id },
            callBack
        });
    };

    /**
     * 权限节点添加
     * @param name
     * @param fid
     * @param belongModule
     * @param treeCode
     * @param sort
     * @param callBack
     */
    addPermissionClassifyRequest = ({ name, fid, belongModule, sort }, callBack) => {
        this.request({
            url: "/cm-sites-sys/permission/classify/add",
            method: "POST",
            contentType: "json",
            body: {
                name, fid, belongModule, sort
            },
            callBack
        });
    };

    addManagerPermission = ({ name, code, remark, permissionClassifyTreeId, permissionSort }, callBack) => {
        this.request({
            url: "/cm-sites-sys/permission/manager/add",
            body: { name, code, remark, permissionClassifyTreeId, permissionSort },
            method: "post",
            contentType: "json",
            callBack
        });
    };

    editPermissionRequest = ({ id, name, remark, permissionClassifyTreeId, belongModule, permissionSort }, callBack) => {
        this.request({
            url: "/cm-sites-sys/permission/manager/edit",
            body: { id, name, remark, permissionClassifyTreeId, belongModule, permissionSort },
            method: "post",
            contentType: "json",
            callBack
        });
    };

    deletePermissionByIdRequest = (id, callBack) => {
        this.request({
            url: "/cm-sites-sys/permission/manager/deleteById",
            body: { permissionId: id },
            method: "post",
            callBack
        });
    };
}
